import { css } from '@emotion/react';

const downloadBoxStyles = css`
    .header {
        display: flex;
    }

    .download-item {
        display: flex;
        .document-thumbnail {
            width: 2rem;
            height: 2rem;
        }
    }

    .package-messages-container {
        .package-info {
            display: flex;
            align-items: center;
        }
        .loader {
            border: 3px solid #bababa;
            border-top: 3px solid #0f5cab;
            border-radius: 50%;
            width: 20px;
            height: 20px;
            margin-right: 10px;
            animation: spin 2s linear infinite;
        }

        @keyframes spin {
            0% {
                transform: rotate(0deg);
            }
            100% {
                transform: rotate(360deg);
            }
        }

        .package-error {
            color: #ec4568;
        }
    }
`;

export const downloadThemeBoxStyles = css`
    .header {
        display: flex;
    }

    .download-item {
        display: flex;
        .document-thumbnail {
            width: 2rem;
            height: 2rem;
        }
    }

    .package-messages-container {
        .package-info {
            display: flex;
            align-items: center;
        }
        .loader {
            border: 3px solid #bababa;
            border-top: 3px solid #0f5cab;
            border-radius: 50%;
            width: 20px;
            height: 20px;
            margin-right: 10px;
            animation: spin 2s linear infinite;
        }

        @keyframes spin {
            0% {
                transform: rotate(0deg);
            }
            100% {
                transform: rotate(360deg);
            }
        }

        .package-info {
            color: var(--color-info-text);
        }

        .package-success {
            color: var(--color-success-text);
        }

        .package-error {
            color: var(--color-warning-text);
        }
    }

    button {
        background-color: var(--buttonComponent-primaryBackgroundColor);
        border-color: var(--buttonComponent-primaryBorderColor);
        border-style: var(--buttonComponent-borderStyle);
        border-width: var(--buttonComponent-borderWidth);
        font-size: var(--buttonComponent-fontSize);
        font-weight: var(--buttonComponent-fontWeight);
        font-family: var(--buttonComponent-fontFamily);
        line-height: var(--buttonComponent-lineHeight);
        padding: var(--buttonComponent-padding);
        border-radius: var(--buttonComponent-borderRadius);
        color: var(--buttonComponent-textColor);
    }
`;

export default downloadBoxStyles;
